import React from 'react'
import {
  AccordionItem,
  AccordionItemContent,
  AccordionItemTrigger,
  AccordionRoot
} from '@/components/ui/accordion'

export default function SimpleAccordion ({ items, allowMultiple, allowToggle, defaultValue }) {
  return (
    <AccordionRoot collapsible multiple={allowMultiple ?? true} defaultValue={defaultValue} variant='enclosed'>
      {items?.map((item, i) =>
        <AccordionItem key={item.key || i} value={item.key}>
          <AccordionItemTrigger display='flex' justifyContent='space-between'>
            {item.label}
          </AccordionItemTrigger>
          <AccordionItemContent>
            {item.content}
          </AccordionItemContent>
        </AccordionItem>
      )}
    </AccordionRoot>
  )
}
